// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2Oa1K","questions":"styles_questions__LVERJ","footer":"styles_footer__138uS"};